import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";

import { styles } from "./LogsList.styles";
import { getLogs, selectSelectedProject, selectLoader, selectLogs } from "../logsSlice";
import { usePrevious } from "../../../common/hooks/usePrevious";
import { Typography, Paper, Tabs, Tab, Grid } from "@material-ui/core";
import moment from "moment";
import SearchBox from "../../../common/components/inputs/SearchBox";

function LogsList({ classes }) {
  const selectedProject = useSelector(selectSelectedProject);
  const loading = useSelector(selectLoader);
  const logs = useSelector(selectLogs);
  const dispatch = useDispatch();
  const prevSelectedProject = usePrevious(selectedProject);
  const [selectedType, setSelectedType] = useState("log");
  const prevSelectedType = usePrevious(selectedType);
  const [search, setSearch] = useState();
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    dispatch(getLogs(selectedProject, selectedType));
    if (
      !logs ||
      logs.length === 0 ||
      prevSelectedProject?.id !== selectedProject?.id ||
      prevSelectedType !== selectedType
    ) {
      if (!loading) {
        dispatch(getLogs(selectedProject, selectedType));
      }
    }
    // eslint-disable-next-line
  }, [selectedProject, selectedType]);

  useEffect(() => {
    scrollToBottom();
    // eslint-disable-next-line
  }, [logs]);

  const highLightSearch = (log) => {
    if (search && search.length > 2) {
      // return log.split(search).join('<b>' + search + "</b>");
      let r = log.split(search);
      return r.map((item, i) => {
        return (
          <span>
            {item}
            {i + 1 < r.length && <span className={classes.highlight}>{search}</span>}
          </span>
        );
      });
      // return <div>{.join(<b>{search}</b>)}</div>;
    }
    return log;
  };

  const printLogs = (logsArray) => {
    // console.log("logsArray: %o", logsArray);
    let currentDate = null;
    let logsArrayRev = [...logsArray].reverse();
    return logsArrayRev.map((item, i) => {
      if (moment(currentDate).get("D") !== moment(item.logDate).get("D")) {
        currentDate = item.logDate;
        return (
          <>
            <Typography className={classes.logDay} key={"log_day_" + i}>
              -- {moment(item.logDate).format("DD MMM")} --
            </Typography>
            <Typography className={classes.log} key={"log_" + i}>
              {moment(item.logDate).format("HH:mm:ss")} {highLightSearch(item.log)}
            </Typography>
          </>
        );
      }
      return (
        <Typography className={classes.log} key={"log_" + i}>
          {moment(item.logDate).format("HH:mm:ss")} {highLightSearch(item.log)}
        </Typography>
      );
    });
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1} direction="column" alignItems="stretch">
        <Grid item style={{ alignSelf: "flex-end" }}>
          <SearchBox fast onEnter={(s) => setSearch(s)} />
        </Grid>
        <Grid item>
          <Paper>
            <Tabs
              value={selectedType}
              indicatorColor="primary"
              textColor="primary"
              onChange={(e, v) => {
                console.log(v);
                setSelectedType(v);
              }}
            >
              <Tab value="log" label="Logs" />
              <Tab value="system" label="System" />
              <Tab value="inout" label="Communications" />
              <Tab value="debug" label="Debug" />
              <Tab value="error" label="Errors" />
            </Tabs>
            <div className={classes.logsContainer}>
              {printLogs(logs || [])}
              <br />
              <br />
              <div ref={messagesEndRef} />
            </div>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(LogsList);
